import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import { IAM_PATH, IAM_SERVER_AUTH_TOKEN_POLICY, IAM_SERVER_SERVICE, IAM_SERVER_SERVICE_GROUP, IAM_SERVER_SERVICE_PAGE, IAM_SERVER_SERVICE_PAGEAUTH } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import Switch from "@mui/material/Switch";
import Loading from "../../../utils/loading/Loading";
import { containsXss } from "../../../utils/security/XssFilter";



/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const GroupDetailModal = ({ id, update }) => {
    const { closeModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(true);
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        id: '',
        groupName: ''
    });

    useEffect(() => {
        const fetchPageData = async () => {
            setLoading(true);
            try {
                // 1. 그룹 정보 조회
                const url = `${IAM_PATH}${IAM_SERVER_SERVICE_GROUP}/get/${id}`;
                const res = await axios.get(url);
                const data = res.data.data;

                // 3. 폼 데이터 세팅
                setFormData({
                    id: id,
                    groupName: data.groupName || ''
                });
            } catch (e) {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            } finally {
                setLoading(false);
            }
        };

        fetchPageData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 서비스스 등록 요청 API
    const handleUpdate = () => {
        for (let key in formData) {
            const value = formData[key];
            if (value === '') {
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            } else if (typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);

        const pageParams = {
            id: formData.id,
            groupName: formData.groupName
        };
        
        const url = IAM_PATH + IAM_SERVER_SERVICE_GROUP + "/update";
        axios.post(url, pageParams)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }

            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    const handleDelete = () => {
        const url = IAM_PATH + IAM_SERVER_SERVICE_GROUP + "/delete/" + formData.id;

        axios.post(url)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>그룹 명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"groupName"}
                                value={formData.groupName}
                                onChange={handleChange} />
                        </li>
                        {/* <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>설명</p>
                            <textarea
                                className={styles.layer__listInput}
                                name={"groupDescription"}
                                value={formData.groupDescription}
                                onChange={handleChange}
                                rows={4} // 원하는 줄 수 조절 가능
                            />
                        </li> */}
                        {/* <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>상위 그룹</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"pageUrl"}
                                value={formData.parentGroupName}
                                readOnly={true}
                            />     
                        </li> */}
                    </ul>

                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    <div className={styles.layer__sensorBtnBox}>
                        <button className={styles.layer__deleteBtn} onClick={handleDelete}>삭제</button>
                        <button className={styles.layer__modifyBtn} onClick={handleUpdate}>수정</button>
                    </div>
                </div>
            }
        </div>
    );
}